import React from 'react';
import { TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';
import JobAdLabel from './JobAdLabel';

function JobAdExplanation(): React.JSX.Element {
    return (
        <div className="flex flex-col gap-2">
            <JobAdLabel label={UIStrings.ProvideInformationForTheJobDescription} />
            <TypographyP className="text-foreground">{UIStrings.DescribeTheJob}</TypographyP>
        </div>
    );
}

export default JobAdExplanation;
